import { createContext, PropsWithChildren } from "react";

import { Menu, MenuShort } from "~/entities/menuEntities";

interface MenuContextData {
  menus: MenuShort[];
  menu: Menu | null | undefined;
}

const MenuContext = createContext<MenuContextData>({
  menus: [],
  menu: null,
});

export const MenuContextProvider = ({
  children,
  menus,
  menu,
}: PropsWithChildren<MenuContextData>) => {
  return (
    <MenuContext.Provider
      value={{
        menus,
        menu,
      }}
    >
      {children}
    </MenuContext.Provider>
  );
};

export default MenuContext;
